import { SETTINGS_RECEIVED, SETTINGS_UNLOADED } from './types';
import api from 'api';

export const settingsReceived = data => ({
  type: SETTINGS_RECEIVED,
  data
})

export const settingsUnloaded = data => ({
  type: SETTINGS_UNLOADED
})

export const unloadSettings = () => dispatch => {
  dispatch(settingsUnloaded())
}

export const getSettings = () => (dispatch) =>
  api.bmc.user.getUserSettings().then( res => {
    dispatch(settingsReceived(res))
  })

export const updateSetting = data => dispatch =>
  api.bmc.user.updateUserSetting(data).then(res=>{
    dispatch(settingsReceived(res))
  })

export const updateSettings = data => dispatch =>
  api.bmc.user.updateUserSettings(data).then(res=>{
    dispatch(settingsReceived(res))
  })
